import { detectBrowserLanguage } from "./detect-browser-language";
import { MULTILINGUAL_ENABLED } from "./multilingual-enabled";
import { portalLanguagePick } from "./portal-language-pick";
import { resolveSignupLanguage } from "./resolve-signup-language";

export const getSignupLanguage = () =>
  resolveSignupLanguage({
    enabled: MULTILINGUAL_ENABLED,
    pick: portalLanguagePick.get(),
    browser: detectBrowserLanguage(),
  });
